//region block: pre-declaration
//endregion
function reset(_this__u8e3s4) {
  _this__u8e3s4.lastIndex = 0;
}
//region block: exports
export {
  reset as reset2ep3wdzn2qbpo,
};
//endregion

//# sourceMappingURL=regexp.mjs.map
